import { lazy } from 'react';
import { Navigate } from 'react-router';
import { SettingsIcon } from '@hf/designSystem/v1';
import type { SpaDefinition } from '@core/routes';
import { settingsPaths } from './layout/settingsPaths';

export { settingsPaths };

const SettingsLayout = lazy(async () => {
  const mod = await import('./layout/SettingsLayout');
  return { default: mod.SettingsLayout };
});
const SettingsPage = lazy(async () => {
  const mod = await import('./pages/SettingsPage');
  return { default: mod.SettingsPage };
});

export const settingsSpa = {
  key: 'settings',
  path: '/settings',
  label: 'Settings',
  icon: <SettingsIcon />,
  public: false,
  nav: 'footer',
  paths: settingsPaths,
  layout: <SettingsLayout />,
  children: [
    { index: true, element: <Navigate to={settingsPaths.account} replace /> },
    { path: settingsPaths.account, element: <SettingsPage /> },
  ],
} as const satisfies SpaDefinition;
